export default {
  namespaced: true,
  state: () => ({
    costPlanHead: {},
    costPlanHeadId: {},
    costSATemplateHead: {},
    costSATemplateHeadId: {}
  }),
  mutations: {
    setCostPlanHead(state, flag) {
      state.costPlanHead = flag;
    },
    setCostPlanHeadId(state, flag) {
      state.costPlanHeadId = flag;
    },
    setCostSATemplateHead(state, flag) {
      state.costSATemplateHead = flag;
    },
    setCostSATemplateHeadId(state, flag) {
      state.costSATemplateHeadId = flag;
    }
  },
  actions: {
    changeCostPlanHead({
      commit
    }, value) {
      commit('setCostPlanHead', value);
      if (value) {
        localStorage.setItem('cost_plan_head', JSON.stringify(value));
      } else {
        localStorage.removeItem('cost_plan_head');
      }
    },
    changeCostPlanHeadId({
      commit
    }, value) {
      commit('setCostPlanHeadId', value);
      if (value) {
        localStorage.setItem('cost_plan_head_id', JSON.stringify(value));
      } else {
        localStorage.removeItem('cost_plan_head_id');
      }
    },
    changeCostSATemplateHead({
      commit
    }, value) {
      commit('setCostSATemplateHead', value);
      if (value) {
        localStorage.setItem('cost_sa_template_head', JSON.stringify(value));
      } else {
        localStorage.removeItem('cost_sa_template_head');
      }
    },
    changeCostSATemplateHeadId({
      commit
    }, value) {
      commit('setCostSATemplateHeadId', value);
      if (value) {
        localStorage.setItem('cost_sa_template_head_id', JSON.stringify(value));
      } else {
        localStorage.removeItem('cost_sa_template_head_id');
      }
    }
  },
  getters: {
    getCostPlanHead(state) {
      const planHead = localStorage.getItem('cost_plan_head');
      return planHead ? JSON.parse(planHead) : state.costPlanHead;
    },
    getCostPlanHeadId(state) {
      const planHeadId = localStorage.getItem('cost_plan_head_id');
      return planHeadId ? JSON.parse(planHeadId) : state.costPlanHeadId;
    },
    getCostSATemplateHead(state) {
      const SATemplateHead = localStorage.getItem('cost_sa_template_head');
      return SATemplateHead ? JSON.parse(SATemplateHead) : state.costSATemplateHead;
    },
    getCostSATemplateHeadId(state) {
      const SATemplateHeadId = localStorage.getItem('cost_sa_template_head_id');
      return SATemplateHeadId ? JSON.parse(SATemplateHeadId) : state.costSATemplateHeadId;
    }
  }
};